import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import dayjs from 'dayjs';

import {
  programBoardList,
  programSnsList,
  trackList as trackListAPI,
  vodList as aodListAPI,
  vodList as vodListAPI,
} from '@/network/apis/apiUri';
import LocalText from '@/localization/local_text';
import NavData from '@/config/data/nav/nav_data.json';
import { transHHmmss } from '../../../common/common_fnc';
import useContent from '@/localization/data_export';

function HomeAnnouncement({ id, mode }) {
  const [announceData, setAnnounceData] = useState();

  useEffect(() => {
    programBoardList({
      board_id: id,
      lan_code: mode,
      hit: true,
      reg_order: 'desc',
      page_info: {
        row_count: 1,
        number: 0,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.item.length) {
            const data = res.data.item[0];
            setAnnounceData({ title: data.title, content: data.content.replace(/(?:\r\n|\r|\n)/g, '<br />') });
          }
        } else setAnnounceData(undefined);
      })
      .catch((e) => setAnnounceData(undefined));
    return () => setAnnounceData(undefined);
  }, [id]);

  if (!announceData) return null;
  return (
    <div className="title_announce">
      <h2 className="title_announce_title">
        <LocalText txt={'radio_main_announcement'} />
      </h2>
      <div className="title_announce_info style-scroll">
        <p>{announceData.title}</p>
        <br />
        <p
          dangerouslySetInnerHTML={{
            __html: announceData.content,
          }}
        ></p>
      </div>
    </div>
  );
}

function HomeTrackList({ id, mode }) {
  const [trackList, setTrackList] = useState();

  useEffect(() => {
    trackListAPI({
      board_id: id,
      start_broadcast_date: dayjs.tz().format('YYYY-MM-DD'),
      end_broadcast_date: dayjs.tz().format('YYYY-MM-DD'),
      is_template: false,
      page_info: { row_count: 10, number: 0 },
    }).then((res) => {
      if (res.status === 200) {
        const dataExist = res.data.item.length;
        if (dataExist) {
          const _data = res.data.item[0].tracklist_item
            .filter((el) => el.useage_type === 'general')
            .reduce((acc, cur) => {
              const partNo = cur.part_no;
              if (!acc[partNo]) acc[partNo] = [];
              acc[partNo].push({
                itemId: cur.id,
                partNo,
                artist: cur.artist.find((el) => el.lan_code === mode).text,
                content: cur.content.find((el) => el.lan_code === mode).text,
                title: cur.title.find((el) => el.lan_code === mode).text,
              });
              return acc;
            }, []);
          setTrackList(_data);
        }
      }
    });
    return () => setTrackList(undefined);
  }, [id]);

  if (!trackList) return null;
  return (
    <section className="radioProgramHome_section">
      <div className="section-inner playlist">
        <h3 className="playlist_title">
          <LocalText txt={'radio_program_tracklist'} />
        </h3>
        <div className="playlist_list list style-scroll">
          {trackList?.map((track, i) => (
            <ul className="list" key={`trackPart_${i + 1}`}>
              <li className="list_part">
                <span className="list_part_title">Part {i + 1}</span>
              </li>
              {track.map((v, i) => (
                <li className="list_data" key={v.itemId}>
                  <p className="list_data_num">{i + 1}</p>
                  <p className="list_data_title">{v.title}</p>
                  <p className="list_data_artist">{v.artist}</p>
                </li>
              ))}
            </ul>
          ))}
        </div>
        <span className="playlist_list_subBoxBlur"></span>
      </div>
    </section>
  );
}

function HomePodcast({ id, pgmId, mode }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const [podcastList, setPodcastList] = useState();

  useEffect(() => {
    aodListAPI({
      lan_code: mode,
      board_id: id,
      program_type: 'radio',
      hit: true,
      type: 'aod',
      start_reg_date: dayjs.tz().subtract(7, 'days').format('YYYY-MM-DD'),
      end_reg_date: dayjs.tz().format('YYYY-MM-DD'),
      reg_order: 'desc',
      page_info: { row_count: 8, number: 0 },
    })
      .then((res) => {
        if (res.status === 200) {
          const dataExist = res.data.item.length;
          if (dataExist) {
            const data = res.data.item.map((el) => ({
              itemId: el.board_item_id,
              broadDate: el.broadcast_date ? el.broadcast_date.slice(0, 10) : '',
              image: el.image_url,
              title: el.title,
              content: el.content,
              duration: transHHmmss(el.media_info.duration),
            }));
            setPodcastList(data);
          }
        }
      })
      .catch(() => setPodcastList(undefined));

    return () => setPodcastList(undefined);
  }, [id]);

  if (!podcastList) return null;
  return (
    <section className="radioProgramHome_section">
      <div className="section-inner podcast">
        <div className="podcast_title">
          <h2 className="podcast_title_text">
            <em className="style-font">Latest</em> <LocalText txt={'radio_podcast_podcast'} />
          </h2>
          <Link to={`${NavData['RADIO_MAIN'].path}/${pgmId}/podcast/${id}`} className="btnViewAll" title={anchorTitle}>
            <LocalText txt={'radio_main_viewAll_1'} />
            &nbsp;
            <LocalText txt={'radio_main_viewAll_2'} />
          </Link>
        </div>
        <ul className="podcast_list">
          {podcastList.map((v, i) => (
            <li className="podcast_list_data data" key={i}>
              <Link
                to={`${NavData['RADIO_MAIN'].path}/${pgmId}/podcast/${id}`}
                className="podcast_list_link"
                title={anchorTitle}
              >
                <div className="data">
                  <h3 className="data_title">{v.title}</h3>
                  <p className="data_date time-fs-fixed">{v.broadDate}</p>
                </div>
                <div className="data">
                  <p className="data_time">{v.duration}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function HomeVod({ id, pgmId, mode }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const [vodList, setVodList] = useState();

  useEffect(() => {
    vodListAPI({
      lan_code: mode,
      board_id: id,
      program_type: 'radio',
      type: 'vod',
      start_reg_date: dayjs.tz().subtract(7, 'day').format('YYYY-MM-DD'),
      end_reg_date: dayjs.tz().format('YYYY-MM-DD'),
      page_info: { row_count: 5, number: 0 },
    }).then((res) => {
      if (res.status === 200) {
        const dataExist = res.data.item.length;
        if (dataExist) {
          const data = res.data.item.map((el) => ({
            id: el.board_item_id,
            vodId: el.vod_id,
            broadDate: el.broadcast_date ? el.broadcast_date.slice(0, 10) : '',
            image: el.image_url,
            title: el.title,
          }));

          setVodList(data);
        } else setVodList(undefined);
      }
    });

    return () => setVodList(undefined);
  }, [id]);

  if (!vodList) return null;
  return (
    <section className="radioProgramHome_section">
      <div className="section-inner vod">
        <div className="vod_title">
          <h2 className="vod_title_text">
            <em className="style-font">Latest</em> <LocalText txt={'menu_vod'} />
          </h2>
          <Link to={`${NavData['RADIO_MAIN'].path}/${pgmId}/vod/${id}`} className="btnViewAll">
            <LocalText txt={'radio_main_viewAll_1'} />
            &nbsp;
            <LocalText txt={'radio_main_viewAll_2'} />
          </Link>
        </div>
        <ul className="vod_list">
          {vodList.map((v, i) => (
            <li className="vod_list_data data" key={v.id}>
              <Link
                to={`${NavData['RADIO_MAIN'].path}/${pgmId}/vod?id=${v.vodId}&board=${id}&sort=vod`}
                className="vod_list_link"
                title={anchorTitle}
              >
                <div className="data_image">
                  <img src={v.image} alt="" className="data_image_img" />
                </div>
                <p className="data_text">{v.title}</p>
                <p className="data_text time-fs-fixed">{v.broadDate}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default function ProgramHome(props) {
  const { mode, pgmDetail, menuData } = props;

  const [snsList, setSnsList] = useState();

  const announceMenu = menuData.find((el) => el.title.match(/announcement/gi));
  const trackMenu = menuData.find((el) => el.title.match(/tracklist/gi));
  const aodMenu = menuData.find((el) => el.title.match(/podcast/gi));
  const vodMenu = menuData.find((el) => el.title.match(/vod/gi));

  useEffect(() => {
    programSnsList({
      program_id: pgmDetail.programId,
      lan_code: mode,
    }).then((res) => {
      if (res.status === 200) {
        const data = res.data.item
          .sort((a, b) => a.order - b.order)
          .filter((el) => el.is_open_allow)
          .map((el) => ({
            id: `sns_${el.sns_id}`,
            title: el.sns_title,
            link: el.url,
            image: el.image.url,
          }));
        if (data.length) setSnsList(data);
        else setSnsList(undefined);
      }
    });
    return () => setSnsList(undefined);
  }, [menuData]);

  return (
    <div id="RadioProgramHome" className="radioProgramHome">
      <section className="radioProgramHome_section">
        <div className="section-inner title">
          <div className={!pgmDetail.onAir ? 'top-prev' : 'top'}>
            <h2 className="title_title">{pgmDetail.title}</h2>
            {!pgmDetail.onAir && <p className="previus">PREVIOUS</p>}
          </div>
          {pgmDetail.onAir &&
            pgmDetail.schedule.map((sch, i) => (
              <div key={`schedule_${i}`}>
                <p className="title_date">{sch.isAllDay ? 'EveryDay' : sch.day}</p>
                <p className="title_time">{sch.time}</p>
              </div>
            ))}
          {!pgmDetail.isNews && announceMenu && <HomeAnnouncement id={announceMenu.boardId} mode={mode} />}
        </div>
        <div className="section-inner intro">
          <div className="intro_header">
            <h2 className="intro_header_title">Introduction</h2>
            <ul className="intro_header_sns sns">
              {snsList &&
                snsList.map((el) => (
                  <li className="sns_list" key={el.id}>
                    <a href={el.link} className="link" target="_blank" rel="noreferrer">
                      <img src={el.image} alt={`${el.title} sns icon`} width={30} />
                    </a>
                  </li>
                ))}
            </ul>
          </div>
          <div className="intro_text style-scroll">
            <p
              className="text"
              dangerouslySetInnerHTML={{
                __html: pgmDetail.content.replace(/(?:\r\n|\r|\n)/g, '<br />'),
              }}
            />
          </div>
        </div>
      </section>
      {trackMenu && <HomeTrackList id={trackMenu.boardId} mode={mode} />}
      {aodMenu && <HomePodcast id={aodMenu.boardId} pgmId={pgmDetail.programId} mode={mode} />}
      {vodMenu && <HomeVod id={vodMenu.boardId} pgmId={pgmDetail.programId} mode={mode} />}
    </div>
  );
}
